export default "__VITE_ASSET__6URIIZN___"